import { http, HttpResponse } from "msw";

export const emptyPositionsMock = http.get("*/api/positions/", () => {
  return HttpResponse.json([]);
});
